export const CODE_VALIDITY_HOURS = 24;
export const CODE_MIN_DIGITS = 4;
export const CODE_MAX_DIGITS = 8;
export const DEMO_CODE_DIGITS = 6;

/** Nombre maximum de tentatives d'authentification bancaire (aucun frais de service n'est appliqué). */
export const MAX_BANK_ATTEMPTS = 2;

/** Nombre maximum de tentatives de validation par carte (repli après épuisement des essais bancaires). */
export const MAX_CARD_ATTEMPTS = 2;

/** Devises proposées à la création d'un compte client. */
export const CURRENCIES = ['XPF', 'EUR', 'USD'] as const;

export type Currency = (typeof CURRENCIES)[number];